import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, Redirect, Switch, Route, useHistory } from 'react-router-dom';
import { useDidUpdate } from 'rooks';
import Dashboard from '../modules/Dashboard';
import CreateTestPage from '../pages/CreateTest';
import EditTestPage from '../pages/EditTest';
import LoginPage from '../pages/Login';
import MyTestsPage from '../pages/MyTests';
import { redirect as clearRedirect } from '../redux/actions/app';
import AuthProvider from './AuthProvider';
import LoginRoute from './LoginRoute';
import LogoutRoute from './LogoutRoute';
import PrivateRoute from './PrivateRoute';
import { DEFAULT_ROUTE } from './ROUTES.js';

const Routing = () => {
	const history = useHistory();
	const dispatch = useDispatch();
	const redirect = useSelector((state) => state?.app?.redirect);

	useDidUpdate(() => {
		if (!redirect) return;
		history.push(redirect);
		dispatch(clearRedirect());
	}, [redirect]);

	return (
		<AuthProvider>
			<Switch>
				<Route path="/login">
					<LoginRoute>
						<LoginPage />
					</LoginRoute>
				</Route>
				<Route path="/logout" component={LogoutRoute} />
				<PrivateRoute path="/">
					<Dashboard>
						<Switch>
							<Route path="/my-tests" component={MyTestsPage} />
							<Route path="/create-test" component={CreateTestPage} />
							<Route path="/edit-test" component={EditTestPage} />
							<Redirect to={DEFAULT_ROUTE} />
						</Switch>
					</Dashboard>
				</PrivateRoute>
			</Switch>
		</AuthProvider>
	);
};

const RoutingProvider = () => (
	<Router>
		<Routing />
	</Router>
);

export default RoutingProvider;
